/* CAF UTM attribution persistence:
 * - Captures first-touch + last-touch UTM/click IDs
 * - Persists to localStorage/cookie
 * - Syncs into Shopify cart attributes so attribution survives checkout
 */
(function () {
  'use strict';

  if (window.__cafUtmAttributionInitialized) return;
  window.__cafUtmAttributionInitialized = true;

  var STORAGE_KEY = 'caf_utm_attribution_v1';
  var COOKIE_KEY = 'caf_utm_attribution_v1';
  var CART_SYNC_KEY = 'caf_utm_cart_sync_sig_v1';
  var COOKIE_DAYS = 90;
  var MAX_ATTR_LENGTH = 255;

  var PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'gclid',
    'fbclid',
    'msclkid',
    'ttclid',
    'twclid',
    'li_fat_id',
    'wbraid',
    'gbraid',
    'dclid'
  ];

  var PARAM_TO_KEY = {
    utm_source: 'source',
    utm_medium: 'medium',
    utm_campaign: 'campaign',
    utm_term: 'term',
    utm_content: 'content',
    utm_id: 'id',
    gclid: 'gclid',
    fbclid: 'fbclid',
    msclkid: 'msclkid',
    ttclid: 'ttclid',
    twclid: 'twclid',
    li_fat_id: 'li_fat_id',
    wbraid: 'wbraid',
    gbraid: 'gbraid',
    dclid: 'dclid'
  };

  function safeJsonParse(value) {
    if (!value || typeof value !== 'string') return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function trimTo(value, maxLength) {
    if (value == null) return '';
    var text = String(value).trim();
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength);
  }

  function getCookie(name) {
    var cookieName = name + '=';
    var decoded = decodeURIComponent(document.cookie || '');
    var parts = decoded.split(';');
    for (var i = 0; i < parts.length; i += 1) {
      var item = parts[i].trim();
      if (item.indexOf(cookieName) === 0) {
        return item.substring(cookieName.length);
      }
    }
    return '';
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (typeof days === 'number') {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Ignore storage errors in private mode/quota limits.
    }
  }

  function parseQueryParams() {
    var result = {};
    var search = window.location.search || '';
    if (!search) return result;

    var query = new URLSearchParams(search);
    for (var i = 0; i < PARAMS.length; i += 1) {
      var rawKey = PARAMS[i];
      var value = query.get(rawKey);
      if (!value) continue;
      var normalizedKey = PARAM_TO_KEY[rawKey];
      result[normalizedKey] = trimTo(value, 500);
    }
    return result;
  }

  function hasAttributionData(values) {
    if (!values || typeof values !== 'object') return false;
    var keys = Object.keys(values);
    for (var i = 0; i < keys.length; i += 1) {
      if (values[keys[i]]) return true;
    }
    return false;
  }

  function getReferrerHost() {
    if (!document.referrer) return '';
    try {
      return new URL(document.referrer).hostname || '';
    } catch (error) {
      return '';
    }
  }

  function createTouch(params) {
    return {
      params: params,
      page_path: window.location.pathname || '/',
      page_url: window.location.origin + window.location.pathname + window.location.search,
      referrer_host: getReferrerHost(),
      captured_at: new Date().toISOString()
    };
  }

  function readAttributionPayload() {
    var localValue = readStorage(STORAGE_KEY);
    var parsedLocal = safeJsonParse(localValue);
    if (parsedLocal) return parsedLocal;

    var cookieValue = getCookie(COOKIE_KEY);
    return safeJsonParse(cookieValue);
  }

  function writeAttributionPayload(payload) {
    if (!payload) return;
    var serialized = JSON.stringify(payload);
    writeStorage(STORAGE_KEY, serialized);
    setCookie(COOKIE_KEY, serialized, COOKIE_DAYS);
  }

  function updateAttributionFromUrl(currentPayload, queryParams) {
    var payload = currentPayload && typeof currentPayload === 'object' ? currentPayload : {};
    if (!payload.version) payload.version = 1;

    if (!hasAttributionData(queryParams)) {
      if (payload.first_touch || payload.last_touch) return payload;
      return null;
    }

    var touch = createTouch(queryParams);
    payload.last_touch = touch;
    payload.updated_at = touch.captured_at;

    if (!payload.first_touch || !payload.first_touch.params || !hasAttributionData(payload.first_touch.params)) {
      payload.first_touch = touch;
    }

    return payload;
  }

  function toCartAttributes(payload) {
    if (!payload || typeof payload !== 'object') return {};

    var firstTouch = payload.first_touch || {};
    var lastTouch = payload.last_touch || {};
    var firstParams = firstTouch.params || {};
    var lastParams = lastTouch.params || {};

    var attributes = {
      utm_ft_source: firstParams.source || '',
      utm_ft_medium: firstParams.medium || '',
      utm_ft_campaign: firstParams.campaign || '',
      utm_ft_term: firstParams.term || '',
      utm_ft_content: firstParams.content || '',
      utm_ft_id: firstParams.id || '',
      utm_ft_referrer_host: firstTouch.referrer_host || '',
      utm_ft_page: firstTouch.page_path || '',
      utm_ft_at: firstTouch.captured_at || '',

      utm_lt_source: lastParams.source || '',
      utm_lt_medium: lastParams.medium || '',
      utm_lt_campaign: lastParams.campaign || '',
      utm_lt_term: lastParams.term || '',
      utm_lt_content: lastParams.content || '',
      utm_lt_id: lastParams.id || '',
      utm_lt_gclid: lastParams.gclid || '',
      utm_lt_fbclid: lastParams.fbclid || '',
      utm_lt_msclkid: lastParams.msclkid || '',
      utm_lt_ttclid: lastParams.ttclid || '',
      utm_lt_twclid: lastParams.twclid || '',
      utm_lt_li_fat_id: lastParams.li_fat_id || '',
      utm_lt_wbraid: lastParams.wbraid || '',
      utm_lt_gbraid: lastParams.gbraid || '',
      utm_lt_dclid: lastParams.dclid || '',
      utm_lt_page: lastTouch.page_path || '',
      utm_lt_at: lastTouch.captured_at || ''
    };

    var keys = Object.keys(attributes);
    for (var i = 0; i < keys.length; i += 1) {
      attributes[keys[i]] = trimTo(attributes[keys[i]], MAX_ATTR_LENGTH);
    }

    return attributes;
  }

  function makeSignature(attributes) {
    try {
      return JSON.stringify(attributes);
    } catch (error) {
      return '';
    }
  }

  function syncCartAttributes(attributes) {
    if (!attributes || !Object.keys(attributes).length) return;

    var signature = makeSignature(attributes);
    if (!signature) return;

    var previousSignature = readStorage(CART_SYNC_KEY);
    if (previousSignature === signature) return;

    var payload = new URLSearchParams();
    var keys = Object.keys(attributes);
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var value = attributes[key];
      if (value == null) continue;
      // Send empty values too, so stale cart attributes are actively cleared.
      payload.append('attributes[' + key + ']', String(value));
    }

    if (!payload.toString()) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: payload.toString(),
      keepalive: true
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to sync cart attributes');
        writeStorage(CART_SYNC_KEY, signature);
      })
      .catch(function () {
        // Ignore network failures; hidden-input fallback still applies on form submit.
      });
  }

  function upsertHiddenInput(form, name, value) {
    if (value == null) return;
    var selector = 'input[name="' + name.replace(/"/g, '\\"') + '"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function injectAttributesIntoForm(form, attributes) {
    if (!form || !attributes) return;
    var keys = Object.keys(attributes);
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var value = attributes[key];
      if (value == null) continue;
      upsertHiddenInput(form, 'attributes[' + key + ']', value);
    }
  }

  function attachSubmitInjection(attributes) {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.getAttribute) return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart') === -1 && action.indexOf('/checkout') === -1) return;
        injectAttributesIntoForm(form, attributes);
      },
      true
    );
  }

  function pushAttributionToDataLayer(payload) {
    if (!payload) return;
    window.cafAttribution = payload;
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'caf_attribution_ready',
        caf_attribution: payload
      });
    }
  }

  var queryParams = parseQueryParams();
  var storedPayload = readAttributionPayload();
  var updatedPayload = updateAttributionFromUrl(storedPayload, queryParams);
  if (updatedPayload) {
    writeAttributionPayload(updatedPayload);
  }

  var attributes = toCartAttributes(updatedPayload);
  syncCartAttributes(attributes);
  attachSubmitInjection(attributes);
  pushAttributionToDataLayer(updatedPayload);
})();
